// extracted by mini-css-extract-plugin
module.exports = {"main":"d264a5"};